import { IRoutesOptions } from "../types/routeInterfaces";

// проверяет, есть ли выбранные маршруты, если нет то 'empty'. если есть то проверяет, можно ли создать вакансию (с разными проектами и разными ВСВ нельзя), и возвращает true или false
export const CheckBeforeCreate = (routes: IRoutesOptions[]) => {
  const checkedItems = routes?.filter((item: IRoutesOptions) => item.checked) || []
  if (checkedItems.length === 0) {
    return 'empty';
  } else {
    const firstCheckedItem = checkedItems[0];

    return checkedItems.every(
      (item: IRoutesOptions) =>
        item.project.id === firstCheckedItem.project.id &&
        item.vsv === firstCheckedItem.vsv
    );
  }
};

// формирует объект для создания вакансии
export const dataForCreate = (routes: IRoutesOptions[]) => {
  const checkedItems = routes.filter((item: IRoutesOptions) => item.checked);
  const type = 'ON_ROUTE'
  const projectRoutes = checkedItems.reduce((acc: { project: { id: number }, routes: number[] }[], el: IRoutesOptions) => {
    const existingProject = acc.find((item: { project: { id: number }, routes: number[] }) => item.project.id === el.project.id);
    if (existingProject) {
      existingProject.routes.push(el.routeNo);
    } else {
      acc.push({ project: { id: el.project.id }, routes: [el.routeNo] });
    }
    return acc;
  }, []);
  const result = {
    type: type,
    projectRoutes: projectRoutes
  }
  return result
}

// формирует объект для добавления маршрута
export const dataForProjectRoutesCheckboxes = (checkboxes: IRoutesOptions[]) => {
  if (checkboxes && checkboxes.length > 0) {
    const projectRoutes = checkboxes.reduce((acc: { project: { id: number }, routes: number[] }[], el: IRoutesOptions) => {
      const existingProjectIndex = acc.findIndex((item: { project: { id: number }, routes: number[] }) => item.project.id === el.project.id);
      if (existingProjectIndex !== -1) {
        acc[existingProjectIndex].routes.push(el.routeNo);
      } else {
        acc.push({ project: { id: el.project.id }, routes: [el.routeNo] });
      }
      return acc;
    }, []);
    return projectRoutes;
  }
}

// формирует объект для создания вакансии через модальное окно
export const dataForCreateVacancyModal = (routes: IRoutesOptions[], list: { project: { id: number }, routes: number[] }[]) => {
  const listById = list.reduce((acc: any, item: any) => ({ ...acc, [item.id]: { ...item, routes: [] } }), {});
  routes.forEach((el: IRoutesOptions) => {
    if (listById[el.project.id]) {
      if (!listById[el.project.id].routes.includes(el.routeNo)) {
        listById[el.project.id].routes.push(el.routeNo);
      }
    }
  });
  const projectRoutes = Object.keys(listById).map(key => {
    return {
      project: { id: listById[key].id },
      routes: listById[key].routes
    }
  });
  return projectRoutes;
};
